import React, { useState } from "react";
import Footer from "./footer";
import { Link } from "react-router-dom";

const About = () => {
    const [isMobileNavOpen, setIsMobileNavOpen] = useState(false);
    
      const toggleNav = () => setIsMobileNavOpen(!isMobileNavOpen);
      const closeNav = () => setIsMobileNavOpen(false);
  return (
    <>
        <div style={{ backgroundColor: "#51477E" }} >


     <header  className="header container">
  <div  className="header-top">
    <div className="logoManager">
        <Link to='/' style={{ textDecoration: "none" }}>
      <h3 style={{ color: "#fff" }}>
        BI <span>Manager</span>
      </h3>
        </Link>
                              
        
    </div>

    {/* Mobile Toggle Button on the right */}
    <button className="nav-toggle d-md-none" onClick={toggleNav}>
      ☰
    </button>
  </div>

  {/* Navigation Menu */}
  <nav className={`nav ${isMobileNavOpen ? "open" : ""}`}>
    <button className="nav-close d-md-none" onClick={closeNav}>✕</button>
    <ul>
      <li><Link to="/" onClick={closeNav}>Home</Link></li>
      <li><Link to="/about" onClick={closeNav}>About</Link></li>
      <li><Link to="/" onClick={closeNav}>CreateRFQ</Link></li>
      <li><Link to="/" onClick={closeNav}>ForVendors</Link></li>
      <li><Link to="/faqs" onClick={closeNav}>FAQ's</Link></li>
      <li><Link to="/contact" onClick={closeNav}>Contact</Link></li>
      <li>
        <Link to="/login">
          <button className="login-btn">Login</button>
        </Link>
      </li>
    </ul>
  </nav>
</header>
    </div>


    <div className="container py-5">
      <h2 className="mb-4" style={{ color: "#FF650F" }}>
        About BI Manager
      </h2>

      <p>
        <strong>BI Manager</strong> is a smart business interaction platform
        designed to simplify RFQ (Request for Quotation) management between
        buyers and vendors.
      </p>

      <p>
        Our platform helps businesses create RFQs, connect with verified
        vendors, compare quotations, and make faster purchasing decisions.
      </p>

      <h5 className="mt-4">🚀 Our Mission</h5>
      <p>
        To streamline procurement processes and empower businesses with
        transparency, efficiency, and control.
      </p>

      <h5 className="mt-4">👨‍💻 Developed By</h5>
      <p>
        This project is proudly developed and powered by{" "}
        <strong style={{ color: "#FF650F" }}>The Nexteck Company</strong>.
      </p>
    </div>
    <Footer/>
    </>
  );
};

export default About;
